import React, { useEffect, useState } from 'react';
import { useAuth, errorMessage } from '../../context/AuthContext';
import RichEditor from '../../components/RichEditor';

const isEmptyHtml = (html) => (html || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim() === '';

// Page « À propos » : contenu en français + version anglaise facultative
export default function AdminPage({ slug }) {
  const { authFetch } = useAuth();
  const [form, setForm] = useState({ title: '', content: '', title_en: '', content_en: '' });
  const [lang, setLang] = useState('fr');
  const [flash, setFlash] = useState(null); // { type: 'ok' | 'error', text }
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetch(`/api/pages/${slug}`)
      .then(r => r.json())
      .then(d => {
        if (d && d.title) setForm({ title: d.title, content: d.content || '', title_en: d.title_en || '', content_en: d.content_en || '' });
      })
      .catch(() => setFlash({ type: 'error', text: 'Erreur : chargement de la page impossible' }));
  }, [slug]);

  const save = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) { setLang('fr'); setFlash({ type: 'error', text: 'Le titre français est obligatoire' }); return; }
    setSaving(true); setFlash(null);
    try {
      const r = await authFetch(`/api/pages/${slug}`, { method: 'PUT', body: JSON.stringify(form) });
      if (!r.ok) throw new Error(await errorMessage(r));
      setFlash({ type: 'ok', text: '✓ page enregistrée' });
      setTimeout(() => setFlash(null), 2000);
    } catch (err) {
      setFlash({ type: 'error', text: `Non enregistré : ${err.message}` });
    } finally {
      setSaving(false);
    }
  };

  const en = lang === 'en';
  const titleKey = en ? 'title_en' : 'title';
  const contentKey = en ? 'content_en' : 'content';
  const enMissing = isEmptyHtml(form.content_en);

  return (
    <div>
      <div className="cv-admin-head">
        <h1 style={{ fontStyle: 'italic' }}>Éditer la page "À propos"</h1>
        <a href={en ? '/about?lang=en' : '/about'} target="_blank" rel="noreferrer" className="btn secondary">voir la page ↗</a>
      </div>
      <p style={{ color: 'var(--ink-soft)', marginBottom: '1.5rem' }}>
        Champ libre — vous pouvez copier/coller votre contenu directement depuis Word, le formatage
        (gras, italique, listes, titres, liens) est conservé. Les images, elles, s'ajoutent avec le bouton 🖼.
      </p>

      <div className="cv-lang-bar">
        <span>Langue du contenu</span>
        <div className="cv-lang-switch" role="group" aria-label="Langue du contenu">
          <button type="button" aria-pressed={!en} className={!en ? 'on' : ''} onClick={() => setLang('fr')}>Français</button>
          <button type="button" aria-pressed={en} className={en ? 'on' : ''} onClick={() => setLang('en')}>English</button>
        </div>
        <span className={`cv-lang-status ${enMissing ? '' : 'ok'}`}>
          {enMissing ? 'Version anglaise vide : les visiteurs en anglais verront la version française' : '✓ version anglaise remplie'}
        </span>
      </div>

      {flash && <div className={`flash ${flash.type === 'error' ? 'error' : ''}`}>{flash.text}</div>}
      <form onSubmit={save}>
        <div className="form-group">
          <label>Titre de la page {en && <span className="cv-lang-tag">EN</span>}</label>
          <input value={form[titleKey]} onChange={e => setForm(prev => ({ ...prev, [titleKey]: e.target.value }))}
            required={!en} placeholder={en ? `FR : ${form.title || ''} — ex : About me` : ''} />
        </div>
        <div className="form-group">
          <label>Contenu {en && <span className="cv-lang-tag">EN</span>}</label>
          {/* key : un éditeur distinct par langue, pour ne jamais mélanger les deux textes */}
          <RichEditor key={lang} value={form[contentKey]} onChange={v => setForm(prev => ({ ...prev, [contentKey]: v }))} minHeight={600} />
        </div>
        <button className="btn" type="submit" disabled={saving}>{saving ? 'enregistrement…' : 'enregistrer'}</button>
      </form>
    </div>
  );
}
